export default class Treatment {
    title = "";
    description = "";
    comments = [];
    dateAdded = new Date().toISOString().substr(0, 10);
    dateAddedTimestamp = 0;
    lastModified = new Date().toISOString().substr(0, 10);
    lastModifiedTimestamp = 0; 
    // These timestamps could be done by converting the moment into a number .format(X) converts to seconds
    patient = {
        age: 0,
        history: "",
        gender: "",
        type: "",
    };
    images = [];
    linkedMeds = [];
    category = "";
    notes = "";
    tags = [];
    organisation = "";
    case = false;
    ownerName = "";
    owner = "";
    public = true;
    upvotes = 0;
    votedBy = [];
 
    constructor(Title, Description, Comments, DateAdded, DateAddedTimestamp, LastModified, LastModifiedTimestamp, Patient, Images, LinkedMeds, Category, Notes, Tags, Organisation, Case, OwnerName, Owner, Public, Upvotes, VotedBy) 
    {
      //Used Tenary operator to determine whether anything was entered/the parameter is defined. If not, set as the default  
      Title ? this.title = Title : this.title = "";
      Description ? this.description = Description : this.description = "";
      Comments ? this.comments = Comments : this.comments = [];
      DateAdded ? this.dateAdded = DateAdded : this.dateAdded = new Date().toISOString().substr(0, 10);
      DateAddedTimestamp ? this.dateAddedTimestamp = DateAddedTimestamp : this.dateAddedTimestamp =(new Date(this.dateAdded).getTime() / 1000);
      LastModified ? this.lastModified = LastModified : this.lastModified = new Date().toISOString().substr(0,10);
      LastModifiedTimestamp ? this.lastModifiedTimestamp = LastModifiedTimestamp : this.lastModifiedTimestamp = (new Date(this.lastModified).getTime() / 1000);
      Patient ? this.patient = Patient : this.patient = {
          age: 0,
          history: "",
          gender: "",
          type: ""
      };
      Images ? this.images = Images : this.images = [];
      LinkedMeds ? this.linkedMeds = LinkedMeds : this.linkedMeds = [];
      Category ? this.category = Category : this.category = "";
      Notes ? this.notes = Notes : this.notes = "";
      Tags ? this.tags = Tags : this.tags = [];
      Organisation ? this.organisation = Organisation : this.organisation = "";
      Case ? this.case = Case : this.case = {};
      OwnerName ? this.ownerName = OwnerName : this.ownerName = "";
      Owner ? this.owner = Owner : this.Owner = "";
      Public ? this.public = Public : this.public = true;
      Upvotes ? this.upvotes = Upvotes : this.upvotes = 0;
      VotedBy ? this.votedBy = VotedBy : this.votedBy = [];
    }

    async validateTreatment(rules, imagesSelected, userId){
        var that = this;
        return new Promise(async function(resolve){
            //Validate the current form entry
            var errorList = [];
            var errorMessage = "";

            //First validate generic entry
            //Title
            if (that.title.length < rules.title.min){
            errorList.push("Title must be a minimum length of " + rules.title.min);
            } else if (that.title.length > rules.title.max){
            errorList.push("Title exceeds maximum length of " + rules.title.max);
            }
            //Category
            if (that.category.length < rules.category.min)
            {
                errorList.push("You must have at least one category selected");          
            }
            //Description
            if (that.description.length < rules.description.min){
                errorList.push("Description must be a minimum length of " + rules.description.min);
            } else if (that.description.length > rules.description.max){
                errorList.push("Description exceeds maximum length of " + rules.description.max);
            }
            //Notes
            if (that.notes.length > rules.notes.max){
                errorList.push("Notes exceeds maximum length of " + rules.notes.max);
            }
            //Age
            if (that.patient.age > rules.age.max){
                errorList.push("Patient Age exceeds the maximum allowed " + rules.age.max)
            }
            if (!that.patient.gender || that.patient.gender === ""){
                errorList.push("The Patient must have a gender selected!");
            }
            if (!that.patient.type || that.patient.type === ""){
                errorList.push("The Patient must have a patient type selected!");
            }
            //Medical History
            if (that.patient.history.length > rules.history.max){
                errorList.push("Medical History exceeds maximum length of " + rules.history.max)
            }
            //Images
            if (imagesSelected.length > 0){
            var imageError = false;
            imagesSelected.forEach(function(image){
                if (image.size > rules.image.max){
                imageError = true;
                }
            });
            if (imageError){
                errorList.push("Image sizes exceed the maximum size of 5MB");
            }
            }

            //Then validate the selected medicine
            
            //User Validation
            //Just check that the owner id is = to the userId input
            if (that.owner !== userId){
                errorList.push("Only the owner of this treatment may modify it");                
            }

            //Produce the error messages in here (push into a list, display a swal at the end)
            if (errorList.length > 0){
            for (var i = 0; i < errorList.length; i++){
                if (i === 0){
                errorMessage = "-" + errorList[i];              
                } else {
                errorMessage = errorMessage + ", \n-" + errorList[i];              
                }
            }

            resolve({result: false, errorMessage: errorMessage});
            } else {
            resolve(true);
            }  
        });
    }
    
    buildTagsList() {
        const newTagsList = [];

        //Split all of the words in the notes into an array
        const wordsList = this.notes.split(' ');
        wordsList.forEach(word => {
            //Check if the first character is a hash
            if (word.indexOf('#') === 0) {
                //If so, add the tag to the array (with or without the hash character???)
                newTagsList.push(word);
            }
        });
        
        this.tags = newTagsList; //Update the treatment tags
    }
}